import {getItems} from '@/store/main'
import {DEFAULT_PARAMS, DEFAULT_SIZE} from '@/helpers/table'

const TYPE_FOR_ITEMS = 'ITEMS'

const state = () => ({
  items: [],
  loading: false,
  params: {...DEFAULT_PARAMS},
  dataPagination: {},
})

const mutations = {
  SET_LOADING(state, {type, loading}) {
    switch (type) {
      case TYPE_FOR_ITEMS:
        state.loading = loading
        break
    }
  },
  SET_ITEMS(state, items) {
    state.items = items
  },
  SET_PAGINATION(state, data) {
    state.dataPagination = {
      pageNumber: data.number + 1,
      totalPages: data.totalPages,
    }
  },
  SET_PAGE_NUMBER(state, {page}) {
    state.params = {
      ...state.params,
      page: page - 1,
    }
  },
  SET_ROW_SIZE(state, size = DEFAULT_SIZE) {
    state.params = {
      ...state.params,
      size,
    }
  },
  SET_SORT_PARAMS(state, {sortNameParam, sortSetParam}) {
    const sortStr = sortNameParam && sortSetParam ? `${sortNameParam},${sortSetParam}` : DEFAULT_PARAMS.sort
    state.params = {
      ...state.params,
      sort: sortStr,
    }
  },
  SET_PARAMS(state, params) {
    state.params = {
      ...state.params,
      ...params,
    }
  },
  DELETE_PARAM(state, param) {
    delete state.params[param.name]
  },
  RESET_PARAMS(state) {
    const size = state.params.size
    state.params = {...DEFAULT_PARAMS, size}
  },
}

const actions = {
  async GET_ITEMS({commit, dispatch}, {url, params}) {
    commit('SET_LOADING', {type: TYPE_FOR_ITEMS, loading: true})
    commit('SET_ITEMS', [])
    await getItems(commit, dispatch, TYPE_FOR_ITEMS, url, params)
  },
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
}
